module.exports = __webpack_public_path__ + "static/media/candy-wings-logo.f2380dba.svg";